import ApiRequest from "../utils/ApiRequest";
// import GlobalData from "../util/GlobalData";

export default class Lsp {
    getAll = async () => {
        return await ApiRequest.set(`/v1/lsp/list-lsp`, "GET");
    }
}